import loopCreate from './loopCreate.js';
import loopFix from './loopFix.js';
import loopDestroy from './loopDestroy.js';
export default {
  loopCreate,
  loopFix,
  loopDestroy
};


//////////////////
// WEBPACK FOOTER
// /var/www/html/wp-content/themes/sage/node_modules/swiper/core/loop/index.js
// module id = 246
// module chunks = 0